import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Opponent cancelled the draw proposal" notification. Subject is the battle's discussion.
 * content: { cancellerName }
 */
export default class DrawCancelledNotification extends Notification {
  icon() {
    return 'fas fa-rotate-left';
  }
  href() {
    const discussion = this.attrs.notification.subject();
    return discussion ? app.route.discussion(discussion) : '#';
  }
  content() {
    var _ref, _user$displayName;
    const user = this.attrs.notification.fromUser();
    const content = this.attrs.notification.content() || {};
    const name = (_ref = (_user$displayName = user == null ? void 0 : user.displayName()) != null ? _user$displayName : content.cancellerName) != null ? _ref : '?';
    return app.translator.trans('forumaker-arena.forum.notifications.draw_cancelled_text', {
      canceller: m("strong", null, name)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/DrawCancelledNotification', DrawCancelledNotification);